export var PasswordResetIA = function PasswordResetIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return RESET_PASSWORD(strictLocalize);
    },
    getDescription: function getDescription() {
      return [IF_YOU_WOULD_LIKE_TO_RESET_YOUR_PASSWORD(strictLocalize), FIRST_STEP_TO_RESET_PASSWORD(strictLocalize), SECOND_STEP_TO_RESET_PASSWORD(strictLocalize), THIRD_STEP_TO_RESET_PASSWORD(strictLocalize), THIS_WILL_SEND_AN_AUTOMATED_EMAIL(strictLocalize)];
    }
  };
};
var RESET_PASSWORD = function RESET_PASSWORD(strictLocalize) {
  return strictLocalize({
    id: "8BAYrT",
    defaultMessage: [{
      "type": 0,
      "value": "Wachtwoord opnieuw instellen"
    }]
  });
};
var IF_YOU_WOULD_LIKE_TO_RESET_YOUR_PASSWORD = function IF_YOU_WOULD_LIKE_TO_RESET_YOUR_PASSWORD(strictLocalize) {
  return strictLocalize({
    id: "uaYTsO",
    defaultMessage: [{
      "type": 0,
      "value": "Volg de onderstaande stappen om je wachtwoord opnieuw in te stellen:"
    }]
  });
};
var FIRST_STEP_TO_RESET_PASSWORD = function FIRST_STEP_TO_RESET_PASSWORD(strictLocalize) {
  return strictLocalize({
    id: "FCoWDD",
    defaultMessage: [{
      "type": 0,
      "value": "1. Klik op de knop Aanmelden in de rechterbovenhoek van de startpagina"
    }]
  });
};
var SECOND_STEP_TO_RESET_PASSWORD = function SECOND_STEP_TO_RESET_PASSWORD(strictLocalize) {
  return strictLocalize({
    id: "jmoi8G",
    defaultMessage: [{
      "type": 0,
      "value": "2. Vul het e-mailadres in waarmee je je aanmeldt en druk op enter"
    }]
  });
};
var THIRD_STEP_TO_RESET_PASSWORD = function THIRD_STEP_TO_RESET_PASSWORD(strictLocalize) {
  return strictLocalize({
    id: "fMuh5K",
    defaultMessage: [{
      "type": 0,
      "value": "3. Klik in het volgende scherm op de link 'Wachtwoord vergeten? Stel het opnieuw in.'"
    }]
  });
};
var THIS_WILL_SEND_AN_AUTOMATED_EMAIL = function THIS_WILL_SEND_AN_AUTOMATED_EMAIL(strictLocalize) {
  return strictLocalize({
    id: "NWeLC2",
    defaultMessage: [{
      "type": 0,
      "value": "Hiermee wordt een automatische e-mail verzonden naar het e-mailadres waarmee je je aanmeldt, hiermee kun je je wachtwoord opnieuw instellen. Als je de e-mail niet ontvangt, controleer dan of je je e-mail correct hebt gespeld en controleer je spammap. Als je problemen tegenkomt, neem contact met ons op via de onderstaande opties."
    }]
  });
};